module.exports = __webpack_public_path__ + "assets/img/e313e14480f51da804c0bba2ea7b8fdb.png";